module.exports = __webpack_public_path__ + "static/media/research.1a8e2d87.png";